module.exports = __webpack_public_path__ + "img/herz_ausgefüllt.b16c5dd1.svg";